(function () {
  var wizard = document.getElementById('postcard-wizard');
  if (!wizard) return;

  var apiBase = wizard.getAttribute('data-api-base') || '';
  var recaptchaSiteKey = wizard.getAttribute('data-recaptcha-site-key') || '';
  var wizardLoadedAt = Date.now(); // used server-side as a bot-timing signal
  var form = document.getElementById('pw-form');
  var toast = document.getElementById('pw-toast');
  var currentStep = 1;
  var generatedSceneToken = null; // opaque token the backend returns so /submit can find the already-generated scene

  function getRecaptchaToken(action) {
    if (!recaptchaSiteKey || typeof grecaptcha === 'undefined') {
      return Promise.resolve('');
    }
    return new Promise(function (resolve) {
      grecaptcha.ready(function () {
        grecaptcha.execute(recaptchaSiteKey, { action: action }).then(resolve);
      });
    });
  }

  function showToast(message, isError) {
    toast.textContent = message;
    toast.style.background = isError ? '#c1503d' : '#0B4A55';
    toast.hidden = false;
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.hidden = true; }, 5000);
  }

  function setStep(step) {
    currentStep = step;
    document.querySelectorAll('.pw-panel').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-panel') === String(step));
    });
    document.querySelectorAll('.pw-step-dot').forEach(function (dot) {
      var dotStep = Number(dot.getAttribute('data-step-dot'));
      dot.classList.toggle('is-active', dotStep === step);
      dot.classList.toggle('is-complete', dotStep < step);
    });
    window.scrollTo({ top: wizard.offsetTop - 20, behavior: 'smooth' });
  }

  function setFieldError(fieldId, message) {
    var errorEl = document.getElementById(fieldId + '-error');
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.hidden = true;
    }
  }

  function moderateText(text) {
    return fetch(apiBase + '/api/moderate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: text })
    })
      .then(function (r) { return r.json(); })
      .catch(function () {
        return { ok: false, reason: 'Could not check this text right now. Please try again.' };
      });
  }

  // ---- Step 1: location + scene generation ----
  var originCityInput = document.getElementById('pw-origin-city');
  var originStateInput = document.getElementById('pw-origin-state');
  var generateBtn = document.getElementById('pw-generate-btn');
  var regenerateBtn = document.getElementById('pw-regenerate-btn');
  var previewBlock = document.getElementById('pw-preview-front');
  var previewFrame = document.getElementById('pw-preview-front-frame');
  var brandOverlay = document.getElementById('pw-preview-brand-overlay');
  var toStep2Btn = document.getElementById('pw-to-step-2');

  var progressBlock = document.getElementById('pw-progress');
  var progressBarFill = progressBlock ? progressBlock.querySelector('.pw-progress__bar-fill') : null;
  var progressDots = document.getElementById('pw-progress-dots');
  var progressMessage = document.getElementById('pw-progress-message');
  var dotsTimer = null;
  var messageTimer = null;

  // Rotating status lines shown while the AI paints the scene (can take up
  // to ~30-40s). The first line sets the time expectation; the rest just
  // keep people's attention and stay on-brand while they wait, the same
  // way ChatGPT and similar tools rotate status text during long
  // operations. Cycles every 3.5s so each line is readable; resets back to
  // the first line whenever progress is hidden so the next run starts by
  // setting expectations again.
  var PROGRESS_MESSAGES = [
    'Hang tight — this can take up to 30 seconds while we paint your scene',
    'Mixing up some paint',
    'Waxing the surfboard',
    'Sketching the shoreline',
    'Catching the perfect wave of inspiration',
    'Adding a splash of sunshine',
    'Pidg is warming up the paintbrush',
    'Sealing it with a little aloha',
    'Almost postcard-perfect'
  ];

  function showProgress() {
    if (progressBlock) progressBlock.hidden = false;
    if (progressBarFill) {
      progressBarFill.style.animation = 'none';
      void progressBarFill.offsetWidth;
      progressBarFill.style.animation = '';
    }
    if (progressDots && !dotsTimer) {
      var states = ['', '.', '..', '...'];
      var i = 0;
      dotsTimer = setInterval(function () {
        progressDots.textContent = states[i % states.length];
        i++;
      }, 450);
    }
    if (progressMessage && !messageTimer) {
      var mi = 0;
      progressMessage.textContent = PROGRESS_MESSAGES[0];
      messageTimer = setInterval(function () {
        mi++;
        progressMessage.textContent = PROGRESS_MESSAGES[mi % PROGRESS_MESSAGES.length];
      }, 3500);
    }
  }

  function hideProgress() {
    if (progressBlock) progressBlock.hidden = true;
    if (dotsTimer) { clearInterval(dotsTimer); dotsTimer = null; }
    if (progressDots) progressDots.textContent = '';
    if (messageTimer) { clearInterval(messageTimer); messageTimer = null; }
    if (progressMessage) progressMessage.textContent = PROGRESS_MESSAGES[0];
  }

  function getLocationDisplay() {
    var city = originCityInput.value.trim();
    var state = originStateInput.value.trim();
    if (city && state) return city + ', ' + state;
    return city || state;
  }

  // NOTE: renderWaveText/splitIntoTwoLines/fitLocationText/the color-preset
  // helpers below are currently unused — "Greetings from" and the location
  // name are painted directly into the AI-generated scene by the backend
  // (see lib/imageGen.js), so the brand overlay is hidden in CSS. Kept here
  // in case we want to switch back to a client-rendered headline later.
  function renderWaveText(el, text, amplitudeEm) {
    el.innerHTML = '';
    var n = text.length;
    var mid = (n - 1) / 2;
    for (var i = 0; i < n; i++) {
      var ch = text[i];
      var span = document.createElement('span');
      span.textContent = ch === ' ' ? ' ' : ch;
      if (n > 1 && mid > 0) {
        var normalized = (i - mid) / mid;
        var offset = -amplitudeEm * (1 - normalized * normalized);
        span.style.transform = 'translateY(' + offset.toFixed(3) + 'em)';
      }
      el.appendChild(span);
    }
  }

  function splitIntoTwoLines(text) {
    var words = text.split(' ');
    if (words.length < 2) return [text, ''];
    var bestSplit = 1;
    var bestDiff = Infinity;
    for (var i = 1; i < words.length; i++) {
      var line1 = words.slice(0, i).join(' ');
      var line2 = words.slice(i).join(' ');
      var diff = Math.abs(line1.length - line2.length);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestSplit = i;
      }
    }
    return [words.slice(0, bestSplit).join(' '), words.slice(bestSplit).join(' ')];
  }

  function fitLocationText(el, frameEl, overlayEl, text) {
    var frameRect = frameEl.getBoundingClientRect();
    var frameWidth = frameRect.width || 400;
    var frameHeight = frameRect.height || (frameWidth * (2 / 3));
    var overlayStyle = getComputedStyle(overlayEl);
    var overlayPaddingX = parseFloat(overlayStyle.paddingLeft || 0) + parseFloat(overlayStyle.paddingRight || 0);
    var overlayContentWidth = overlayEl.clientWidth
      ? (overlayEl.clientWidth - overlayPaddingX)
      : (frameWidth * 0.88);
    var availableWidth = overlayContentWidth * 0.98;
    var maxFont = Math.min(frameWidth * 0.22, frameHeight * 0.19);
    var minFont = frameWidth * 0.028;

    var elStyle = getComputedStyle(el);
    var measurer = document.createElement('span');
    measurer.style.position = 'absolute';
    measurer.style.left = '-9999px';
    measurer.style.top = '0';
    measurer.style.visibility = 'hidden';
    measurer.style.whiteSpace = 'nowrap';
    measurer.style.fontFamily = elStyle.fontFamily;
    measurer.style.fontWeight = elStyle.fontWeight;
    measurer.style.letterSpacing = elStyle.letterSpacing;
    measurer.style.textTransform = elStyle.textTransform;
    document.body.appendChild(measurer);

    function widestLineFont(lines) {
      var fontSize = maxFont;
      var guard = 0;
      while (guard < 60) {
        measurer.style.fontSize = fontSize + 'px';
        var widest = 0;
        for (var i = 0; i < lines.length; i++) {
          if (!lines[i]) continue;
          measurer.textContent = lines[i];
          widest = Math.max(widest, measurer.scrollWidth);
        }
        if (widest <= availableWidth || fontSize <= minFont) break;
        fontSize -= Math.max(1, fontSize * 0.04);
        guard++;
      }
      return fontSize;
    }

    var oneLineFont = widestLineFont([text]);
    var twoLines = splitIntoTwoLines(text);
    var twoLineFont = twoLines[1] ? widestLineFont(twoLines) : 0;

    document.body.removeChild(measurer);

    el.innerHTML = '';
    if (twoLineFont > oneLineFont) {
      el.style.whiteSpace = 'normal';
      el.style.fontSize = twoLineFont + 'px';
      var line1El = document.createElement('div');
      var line2El = document.createElement('div');
      renderWaveText(line1El, twoLines[0], 0.16);
      renderWaveText(line2El, twoLines[1], 0.16);
      el.appendChild(line1El);
      el.appendChild(line2El);
    } else {
      el.style.whiteSpace = 'nowrap';
      el.style.fontSize = oneLineFont + 'px';
      renderWaveText(el, text, 0.16);
    }
  }

  var LOCATION_TEXT_PRESETS = {
    darkOnLight: {
      color: '#0B4A55',
      textShadow: '0 0 6px rgba(255,255,255,0.6), 0 0 14px rgba(255,255,255,0.35), 0 3px 6px rgba(0,0,0,0.25)'
    },
    lightOnDark: {
      color: '#F5E9C8',
      textShadow: '-1px -1px 0 rgba(0,0,0,0.35), 1px -1px 0 rgba(0,0,0,0.35), -1px 1px 0 rgba(0,0,0,0.35), 1px 1px 0 rgba(0,0,0,0.35), 0 4px 10px rgba(0,0,0,0.35)'
    }
  };

  function applyLocationTextPreset(el, presetName) {
    var preset = LOCATION_TEXT_PRESETS[presetName] || LOCATION_TEXT_PRESETS.darkOnLight;
    el.style.color = preset.color;
    el.style.textShadow = preset.textShadow;
  }

  function pickPresetForImage(imgEl) {
    try {
      var sampleW = 40, sampleH = 20;
      var canvas = document.createElement('canvas');
      canvas.width = sampleW;
      canvas.height = sampleH;
      var ctx = canvas.getContext('2d');
      var naturalW = imgEl.naturalWidth || 1;
      var naturalH = imgEl.naturalHeight || 1;
      ctx.drawImage(imgEl, 0, 0, naturalW * 0.7, naturalH * 0.35, 0, 0, sampleW, sampleH);
      var data = ctx.getImageData(0, 0, sampleW, sampleH).data;
      var total = 0, count = 0;
      for (var i = 0; i < data.length; i += 4) {
        total += 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
        count++;
      }
      var avgLuminance = total / count;
      return avgLuminance > 150 ? 'darkOnLight' : 'lightOnDark';
    } catch (e) {
      return 'darkOnLight';
    }
  }

  function generateScene() {
    var city = originCityInput.value.trim();
    var state = originStateInput.value.trim();
    if (!city || !state) {
      setFieldError('pw-origin', 'Tell us the city and state this postcard is from.');
      return;
    }
    var location = city + ', ' + state;
    generateBtn.disabled = true;
    generateBtn.textContent = 'Generating...';
    // Show the "hang tight, up to 30 seconds" progress UI immediately on
    // click, rather than waiting for the moderation check to resolve first.
    // The moderation API round-trip (plus any backend cold-start latency)
    // was creating a silent gap between clicking the button and any visible
    // feedback, which read as the page being unresponsive.
    showProgress();

    moderateText(location).then(function (modResult) {
      if (!modResult.ok) {
        hideProgress();
        setFieldError('pw-origin', modResult.reason || 'Please choose a different word.');
        generateBtn.disabled = false;
        generateBtn.textContent = 'Generate my postcard';
        return;
      }
      setFieldError('pw-origin', null);
      generateBtn.textContent = 'Painting your postcard';

      getRecaptchaToken('generate_scene').then(function (recaptchaToken) {
        return fetch(apiBase + '/api/generate-scene', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ city: city, state: state, recaptchaToken: recaptchaToken })
        });
      })
        .then(function (r) { return r.json(); })
        .then(function (result) {
          hideProgress();
          if (!result.ok) {
            showToast(result.message || "Couldn't generate that scene. Please try again.", true);
            generateBtn.disabled = false;
            generateBtn.textContent = 'Generate my postcard';
            return;
          }
          generatedSceneToken = result.sceneToken;
          var imgSrc = /^https?:\/\//.test(result.previewImageUrl)
            ? result.previewImageUrl
            : apiBase + result.previewImageUrl;
          // "Greetings from" and the location name are painted directly into
          // the AI-generated scene by the backend (see the Headline text
          // paragraph in lib/imageGen.js) — the brand overlay is hidden in
          // CSS so nothing needs to be drawn here.
          var sceneImg = document.getElementById('pw-preview-scene-img');
          previewBlock.hidden = false;
          if (sceneImg) {
            sceneImg.src = imgSrc;
            sceneImg.alt = 'Postcard preview for ' + location;
          }
          toStep2Btn.disabled = false;
          generateBtn.disabled = false;
          generateBtn.textContent = 'Generate my postcard';
        })
        .catch(function () {
          hideProgress();
          showToast("Couldn't reach the postcard service. Please try again.", true);
          generateBtn.disabled = false;
          generateBtn.textContent = 'Generate my postcard';
        });
    });
  }

  generateBtn.addEventListener('click', generateScene);
  regenerateBtn.addEventListener('click', generateScene);

  document.querySelectorAll('[data-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setStep(Number(btn.getAttribute('data-back')));
    });
  });

  toStep2Btn.addEventListener('click', function () { setStep(2); });

  document.getElementById('pw-to-step-3').addEventListener('click', function () {
    var note = document.getElementById('pw-note').value.trim();
    var senderName = document.getElementById('pw-sender-name').value.trim();
    if (!note) { setFieldError('pw-note', 'Add a short note.'); return; }
    if (!senderName) { setFieldError('pw-sender-name', 'Let them know who this is from.'); return; }

    Promise.all([moderateText(note), moderateText(senderName)]).then(function (results) {
      var noteResult = results[0];
      var nameResult = results[1];
      var hasError = false;
      if (!noteResult.ok) { setFieldError('pw-note', noteResult.reason || 'Please rephrase your note.'); hasError = true; }
      else setFieldError('pw-note', null);
      if (!nameResult.ok) { setFieldError('pw-sender-name', nameResult.reason || 'Please use a different name.'); hasError = true; }
      else setFieldError('pw-sender-name', null);
      if (!hasError) setStep(3);
    });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var submitBtn = document.getElementById('pw-submit-btn');
    var submitNotice = document.getElementById('pw-submit-notice');
    var email = document.getElementById('pw-email').value.trim();
    var recipientName = document.getElementById('pw-recipient-name').value.trim();

    if (!generatedSceneToken) {
      showToast('Please generate a postcard scene in step 1 first.', true);
      setStep(1);
      return;
    }

    Promise.all([moderateText(recipientName)]).then(function (results) {
      if (!results[0].ok) {
        setFieldError('pw-recipient-name', results[0].reason || 'Please use a different name.');
        return;
      }
      setFieldError('pw-recipient-name', null);

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
      if (submitNotice) submitNotice.hidden = false;

      var payload = {
        sceneToken: generatedSceneToken,
        location: getLocationDisplay(),
        note: document.getElementById('pw-note').value.trim(),
        senderName: document.getElementById('pw-sender-name').value.trim(),
        recipientName: recipientName,
        address1: document.getElementById('pw-address1').value.trim(),
        address2: document.getElementById('pw-address2').value.trim(),
        city: document.getElementById('pw-city').value.trim(),
        state: document.getElementById('pw-state').value.trim(),
        zip: document.getElementById('pw-zip').value.trim(),
        email: email,
        website: (document.getElementById('pw-website') || {}).value || '',
        formLoadedAt: wizardLoadedAt
      };

      getRecaptchaToken('submit_postcard').then(function (recaptchaToken) {
        payload.recaptchaToken = recaptchaToken;
        return fetch(apiBase + '/api/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
        .then(function (r) { return r.json(); })
        .then(function (result) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send my postcard';
          if (submitNotice) submitNotice.hidden = true;
          if (!result.ok) {
            if (result.code === 'EMAIL_ALREADY_USED') {
              showToast("Looks like you've already sent a Pidgin Toes postcard with this email.", true);
            } else if (result.code === 'MONTHLY_CAP_REACHED') {
              showToast("We've reached this month's postcard limit — please try again next month!", true);
            } else {
              showToast(result.message || 'Something went wrong. Please try again.', true);
            }
            return;
          }
          var discountBlock = document.getElementById('pw-discount');
          var discountCodeEl = document.getElementById('pw-discount-code');
          var discountExpiryEl = document.getElementById('pw-discount-expiry');
          if (discountBlock && result.discountCode) {
            if (discountCodeEl) discountCodeEl.textContent = result.discountCode;
            if (discountExpiryEl && result.discountExpiresAt) {
              var expiry = new Date(result.discountExpiresAt);
              var formatted = expiry.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
              discountExpiryEl.textContent = '25% off your next order (shipping not included) — good for 30 days, through ' + formatted + '.';
            }
            discountBlock.hidden = false;
          }
          setStep('done');
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send my postcard';
          if (submitNotice) submitNotice.hidden = true;
          showToast("Couldn't reach the postcard service. Please try again.", true);
        });
    });
  });

  setStep(1);
})();